module.exports = __webpack_public_path__ + "assets/img/20-double-eleven_prize-two.edc4b7a5.png";